import React from "react";
import { Card } from "antd";

interface StoreCardProps {
  store: any;
}

const StoreCard: React.FC<StoreCardProps> = ({ store }) => {
  return <Card title={store.name}>{store.description}</Card>;
};

export default StoreCard;
